import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { StateNames } from '../models/vendor.model';
import { ConfigureFormFieldsView } from '../models/ConfigureFormFieldsView';
import { forkJoin, merge, Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-provider-details',
  templateUrl: './provider-details.component.html',
  styleUrls: ['./provider-details.component.css','../shared/css/common.css']
})
export class ProviderDetailsComponent implements OnInit {

  providerForm :FormGroup = this.providerFormBuilder.group({});
  providerFormData: any;
  formdata : any | null;
  payorkey: number;
  title: string = "Provider";
  isformloaded: boolean = false;
  isInstruction: boolean = false;
  instructionText!: string | null;

  providerFormData1: any = {};
  providerFormData2: any = {};
  providerFormData3: any = {};
  internalInvolvedPartiesKey:number=0;
  isNameRequired:boolean = false;
  isRequiredIdLabelVisible:boolean = false;
  isFormsValid : boolean = false;
  requiredIdFormat:string = "";
  private nameSubscription?: Subscription;
  private stateSubscription?: Subscription;
  private formSubscription?: Subscription;
  private initCount = 0;

  statelist: StateNames[] = [];
  primaryColor?: string = "";
  configureFormFields: ConfigureFormFieldsView[] = [];
  
  @Input() inputDetails: any;

  @Output() formValidationEvent: EventEmitter<{isValid:boolean, isChanged: boolean}> = new EventEmitter();
  
  constructor(
    private providerFormBuilder: FormBuilder, 
    private router: Router,
    private vendorService: VendorService,
    private referalService: ReferalFormService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal
  ) {
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
  }
  
  providerFormPart1 = this.providerFormBuilder.group({});
  providerFormPart2= this.providerFormBuilder.group({});
  providerFormPart3 = this.providerFormBuilder.group({});

  ngOnInit(): void {
    this.formdata = this.vendorService.getSessionData();
    this.providerFormData = this.inputDetails == null ? this.formdata.providerDetails : this.inputDetails;
    this.providerFormData1["controls"] = this.providerFormData.controls.slice(0, 10);
    this.providerFormData2["controls"] = this.providerFormData.controls.slice(10, 20);
    this.providerFormData3["controls"] = this.providerFormData.controls.slice(20, 30);
    let currentUrl = window.location.hash;
    if(currentUrl.includes('additionalInvolvedParties')) {
      const involvedCtrl = this.formdata.involvedParties.controls.find((x: { name: string; }) => x.name == "additionalInvolvedType");
      this.internalInvolvedPartiesKey = involvedCtrl.value;
      if(involvedCtrl?.value) {
        this.title = involvedCtrl.options.find((y: { value: string }) => y.value == involvedCtrl.value)?.key;
      }
    }
    else {
      const involvedCtrl = this.formdata.witnessDetails.controls.find((x: { name: string }) => x.name == 'involvedType');
      this.internalInvolvedPartiesKey = involvedCtrl.value;
      if(involvedCtrl?.value) {
        this.title = involvedCtrl.options.find((y: { value: string }) => y.value == involvedCtrl.value)?.key;
      }
    }

    this.vendorService.getLookUpProviderSpeciality(this.payorkey).subscribe((result) => {
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pSpecialty').options =
        result.map((x) => ({ value: x.IdentifierCode, key: x.Description }));
    });

    this.vendorService.getLookUpProviderType(this.payorkey).subscribe((result) => {
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pType').options =
        result.map((x) => ({ value: x.IdentifierCode, key: x.Description }));
    });

    this.vendorService.getInvolvedPartyById(this.internalInvolvedPartiesKey, this.payorkey).subscribe((result) => {
      if (result) {
        this.requiredIdFormat = result.ProviderIdInstruction;
        this.isRequiredIdLabelVisible = !!(this.requiredIdFormat && this.requiredIdFormat.length > 0);
      }
    });

    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result) => {
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText = result.Instruction?.replace('<img ', '<img title="Header" ');
      this.instructionText = instructionText;
    });

    let getStatesApi = this.vendorService.getStateNames();
    let getSubjectRequiredFieldApi = this.vendorService.getSubjectRequiredFieldsByInvolvedParty(this.internalInvolvedPartiesKey, this.payorkey);
    forkJoin([getSubjectRequiredFieldApi, getStatesApi]).subscribe((response: any) => {
      let result = response[0];
      if(result.EitherOrOptions == 1) {
        this.isNameRequired = true;
      }
      this.configureFormFields = result.ConfigureFormFields ?? [];
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pFirstName').validators.required = result.FirstName;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pLastName').validators.required = result.LastName;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pOrgName').validators.required = result.OrganizationName;
      this.providerFormData.controls.find((x: { name: string; }) => x.name == "pMiddleName").validators.required = result.MiddleName;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pDateOfBirth').validators.required = result.DateofBirth;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pSsn').validators.required = result.SSN;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pLicenseNo').validators.required = result.License;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pProviderID').validators.required = result.ManualSubjectID;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pNPInumber').validators.required = result.NPI;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pTIN').validators.required = result.FederalTIN;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pMedicaidId').validators.required = result.MedicaidId;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pMedicareId').validators.required = result.MedicareNo;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pOtherId').validators.required = result.OtherID;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pType').validators.required = result.ProviderType;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pSpecialty').validators.required = result.ProviderSpecialty;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pTaxonomy').validators.required = result.TaxonomyID;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pOther').validators.required = result.Other;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pStreetAddress1').validators.required = result.AddressLine1;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pCity').validators.required = result.City;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pState').validators.required = result.State;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pCounty').validators.required = result.County;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pZip').validators.required = result.ZipCode;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pCountry').validators.required = result.Country;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pPhone').validators.required = result.Phone;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pFax').validators.required = result.Fax;
      this.providerFormData.controls.find((x: { name: string }) => x.name == 'pEmail').validators.required = result.Email;

      this.isformloaded = true;
      this.statelist = response[1];
      this.providerFormData.controls.find((x: { name: string; }) => x.name == "pState").options = response[1].map((x: any) => { return { "value": x.Abbreviation, "key": x.Name } });
      const countyValue = this.providerFormData3.controls.find((x: { name: string; }) => x.name == "pCounty").value;
      
      setTimeout(() => {
        if (countyValue) {
          (this.providerFormPart3.get('pCounty') as any)?.setValue(countyValue);
        }
      }, 1000);
      this.setConfiguredFormFields();
    });

    this.providerFormPart1.valueChanges.subscribe(() => this.recheckFormValidity());
    this.providerFormPart2.valueChanges.subscribe(() => this.recheckFormValidity());
    this.providerFormPart3.valueChanges.subscribe(() => this.recheckFormValidity());

    setTimeout(() => {
      const colorFromStorage = localStorage.getItem('primaryCssColor');
      if (colorFromStorage) {
        this.primaryColor = colorFromStorage.toString();
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  private recheckFormValidity() {
    const allValid =
      this.providerFormPart1.valid &&
      this.providerFormPart2.valid &&
      this.providerFormPart3.valid &&
      this.dobValidation();
    if (this.isFormsValid !== allValid) {
      this.isFormsValid = allValid;
    }

    var tempArr ={
      controls: []
    }
    tempArr.controls = this.providerFormData1.controls.concat(this.providerFormData2.controls,this.providerFormData3.controls);

    this.formdata.providerDetails = tempArr;
    this.vendorService.updateData(this.formdata);
    let isFormChanged = this.providerFormPart1.dirty || this.providerFormPart2.dirty || this.providerFormPart3.dirty;
    this.formValidationEvent.emit({isValid: allValid, isChanged: isFormChanged});
  }

  private updateNameValidators() {
    if (!this.isNameRequired) return;

    const firstVal = ((this.providerFormPart1.get('pFirstName')?.value as unknown) as string || '').trim();
    const lastVal  = ((this.providerFormPart1.get('pLastName')?.value as unknown) as string || '').trim();
    const orgVal   = ((this.providerFormPart1.get('pOrgName')?.value as unknown) as string || '').trim();
    const hasAny = !!(firstVal || lastVal || orgVal);
    const firstCtrl = this.providerFormPart1.get('pFirstName');
    const lastCtrl  = this.providerFormPart1.get('pLastName');
    const orgCtrl   = this.providerFormPart1.get('pOrgName');

    if (hasAny) {
      [firstCtrl, lastCtrl, orgCtrl].forEach(ctrl => ctrl?.clearValidators());
      this.providerFormData1.controls.find((x:any)=>x.name=='pFirstName').validators.required = false;
      this.providerFormData1.controls.find((x:any)=>x.name=='pLastName').validators.required = false;
      this.providerFormData1.controls.find((x:any)=>x.name=='pOrgName').validators.required = false;
    } else {
      [firstCtrl, lastCtrl, orgCtrl].forEach(ctrl => ctrl?.setValidators([Validators.required]));
      this.providerFormData1.controls.find((x:any)=>x.name=='pFirstName').validators.required = true;
      this.providerFormData1.controls.find((x:any)=>x.name=='pLastName').validators.required = true;
      this.providerFormData1.controls.find((x:any)=>x.name=='pOrgName').validators.required = true;
    }

    [firstCtrl, lastCtrl, orgCtrl].forEach(ctrl => ctrl?.updateValueAndValidity({ emitEvent: false }));
    this.formValidate(null);
  }

  setConfiguredFormFields() {
    let oldProviderSubjectId = this.providerFormData.controls.find((x: { name: string; }) => x.name == "pProviderID").label;
    let providerSubjectId = this.manualFieldConfig('OnlineIntake', 'InvolvedParty', 'InvolvedPartyType', 'ProviderSubjectId', oldProviderSubjectId);
    this.providerFormData.controls.find((x: { name: string; }) => x.name == "pProviderID").label = providerSubjectId;
  }
  

  manualFieldConfig(formCategory: string, formName: string, subFormName: string, fieldName: string, defaultValue: string): string | null {
    let result = defaultValue;
    
    if(this.configureFormFields != null && this.configureFormFields.length > 0) {
        this.configureFormFields.forEach((field) => {
            if (
                field.FormCategory &&
                field.FormName &&
                field.SubFormName &&
                field.FieldName &&
                field.FormCategory.toLowerCase() === formCategory.toLowerCase() &&
                field.FormName.toLowerCase() === formName.toLowerCase() &&
                field.SubFormName.toLowerCase() == subFormName.toLowerCase() &&
                field.FieldName.toLowerCase() === fieldName.toLowerCase() &&
                field.FormTypeKey == this.internalInvolvedPartiesKey
            ) {
                result = field.LabelValue ?? defaultValue;
            }
        });
    }

    return result;
  }

  childInitComplete() {
    this.initCount++;
    this.formValidate(null);
    if (this.initCount === 3) {
      this.setupSubscriptions();
    }
  }
  private setupSubscriptions() {
    if (this.isNameRequired) {
      const firstCtrl = this.providerFormPart1.get('pFirstName');
      const lastCtrl  = this.providerFormPart1.get('pLastName');
      const orgCtrl   = this.providerFormPart1.get('pOrgName');

      if (firstCtrl && lastCtrl && orgCtrl) {
        this.nameSubscription = merge(
          firstCtrl.valueChanges,
          lastCtrl.valueChanges,
          orgCtrl.valueChanges
        ).subscribe(() => {
          this.updateNameValidators();
        });
      }

      this.updateNameValidators();
    }

  this.formSubscription = merge(
    this.providerFormPart1.valueChanges,
    this.providerFormPart2.valueChanges,
    this.providerFormPart3.valueChanges
  ).subscribe(() => {
    this.formValidate(null);
  });
}

  providerDetailsSubmit() {
    if (this.providerFormPart1.valid && this.providerFormPart2.valid && this.providerFormPart3.valid) {
      var tempArr ={
        controls: []
      }
      tempArr.controls = this.providerFormData1.controls.concat(this.providerFormData2.controls,this.providerFormData3.controls);

      this.formdata.providerDetails = tempArr;
    this.vendorService.updateData(this.formdata);
      this.router.navigate(['validateParticipant']);
    }
  }

  back() {
    var tempArr ={
      controls: []
    }
    tempArr.controls = this.providerFormData1.controls.concat(this.providerFormData2.controls,this.providerFormData3.controls);

    this.formdata.providerDetails = tempArr; 
    this.vendorService.updateData(this.formdata);
    this.router.navigate(['involvedParties']);
  }

  valueChange(data: any) {
    
    if(data && data.name == 'pState') {
      this.vendorService.getStateCounties(this.statelist.find( y => y.Id == data.value.target.selectedIndex)?.Abbreviation?? "").subscribe((result)=>{
        this.providerFormData3.controls.find((x: { name: string; }) => x.name == "pCounty").options = result.map(x => {return { "value" : x.County, "key" : x.County}});
      })
      this.providerFormData3.controls.find((x: { name: string; }) => x.name == "pCounty").disabled = false;
    }

    if (this.isNameRequired) {
      let firstnameVal = this.providerFormData1.controls.find((x: any) => x.name === 'pFirstName').value;
      let lastnameVal = this.providerFormData1.controls.find((x: any) => x.name === 'pLastName').value;
      let orgnameVal = this.providerFormData1.controls.find((x: any) => x.name === 'pOrgName').value;
      if ((firstnameVal && firstnameVal !== '') || (lastnameVal && lastnameVal !== '') ||
        (orgnameVal && orgnameVal !== '')) {
        this.providerFormPart1.get('pFirstName')?.clearValidators();
        this.providerFormPart1.get('pFirstName')?.updateValueAndValidity();
        this.providerFormPart1.get('pLastName')?.clearValidators();
        this.providerFormPart1.get('pLastName')?.updateValueAndValidity();
        this.providerFormPart1.get('pOrgName')?.clearValidators();
        this.providerFormPart1.get('pOrgName')?.updateValueAndValidity();
        this.providerFormData1.controls.find((x: { name: string; }) => x.name == "pFirstName").validators.required = false;
        this.providerFormData1.controls.find((x: { name: string; }) => x.name == "pLastName").validators.required = false;
        this.providerFormData1.controls.find((x: { name: string; }) => x.name == "pOrgName").validators.required = false;
      }
      else {
        this.providerFormPart1.get('pFirstName')?.setValidators([Validators.required]);
        this.providerFormPart1.get('pFirstName')?.updateValueAndValidity();
        this.providerFormPart1.get('pLastName')?.setValidators([Validators.required]);
        this.providerFormPart1.get('pLastName')?.updateValueAndValidity();
        this.providerFormPart1.get('pOrgName')?.setValidators([Validators.required]);
        this.providerFormPart1.get('pOrgName')?.updateValueAndValidity();
        this.providerFormData1.controls.find((x: { name: string; }) => x.name == "pFirstName").validators.required = true;
        this.providerFormData1.controls.find((x: { name: string; }) => x.name == "pLastName").validators.required = true;
        this.providerFormData1.controls.find((x: { name: string; }) => x.name == "pOrgName").validators.required = true;
      }
    }
    if (data && data.name === 'pDateOfBirth') {
      this.dobValidation();
    }
    this.formValidate(data);
    
    var tempArr ={
      controls: []
    }
    tempArr.controls = this.providerFormData1.controls.concat(this.providerFormData2.controls,this.providerFormData3.controls);

    this.formdata.providerDetails = tempArr;
    this.vendorService.updateData(this.formdata);
  }

  openInstruction() {
      const result  = this.modalService.open(InstructionsComponent, {size: 'lg',  ariaLabelledBy: 'Instructions'});
      result.componentInstance.name = this.instructionText;
    }

    formValidate(data: any) {
      if (this.providerFormPart1.valid && this.providerFormPart2.valid && this.providerFormPart3.valid && this.dobValidation()) {
        this.isFormsValid = true;
      } else {
        this.isFormsValid = false;
      }
    }

  private dobValidation(): boolean {
    let result = true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const dobConfig =
      this.providerFormData1.controls.find((x: any) => x.name === 'pDateOfBirth') ||
      this.providerFormData2.controls.find((x: any) => x.name === 'pDateOfBirth') ||
      this.providerFormData3.controls.find((x: any) => x.name === 'pDateOfBirth');

    const dobVal = dobConfig && dobConfig.value ? new Date(dobConfig.value) : null;
    let errorText = '';
    if (dobVal && dobVal > today) {
      errorText = 'Date cannot be in the future.';
      result = false;
    }

    const ctrl = this.providerFormPart1.get('pDateOfBirth') || this.providerFormPart2.get('pDateOfBirth') || this.providerFormPart3.get('pDateOfBirth');
    if (ctrl) {
      if (!result) {
        ctrl.setErrors({ ...(ctrl.errors || {}), futureDate: true });
      } else {
        if (ctrl.errors && ctrl.errors['futureDate']) {
          const { futureDate, ...rest } = ctrl.errors;
          Object.keys(rest).length ? ctrl.setErrors(rest) : ctrl.setErrors(null);
        }
      }
    }

    const el = document.getElementById('pDateOfBirth_Error');
    if (el) {
      el.textContent = errorText;
    }

    return result;
  }

  ngOnDestroy() {
    this.nameSubscription?.unsubscribe();
    this.stateSubscription?.unsubscribe();
    this.formSubscription?.unsubscribe();
  }

}
